export class LogDates {
    transaction: Array<Date>;
    headedkiosk: Array<Date>;
    webapp: Array<Date>;
    wifidirect: Array<Date>;
    cloudsync: Array<Date>;
}
   